import { Text, VStack } from '@chakra-ui/react';
import { SystemProps } from '@chakra-ui/system';
import { format } from 'date-fns';

type Props = {
  label: string;
  date: string;
  align?: SystemProps['alignItems'];
};

export const InsuranceDateText = ({
  label,
  date,
  align = 'flex-start',
}: Props) => (
  <VStack gap={0} align={align}>
    <Text opacity=".7" fontSize="12px" lineHeight="14px">
      {label}
    </Text>
    <Text>{date ? format(date, 'M/d/yyyy') : 'N/A'}</Text>
  </VStack>
);
